import AodObject from "./AodObject";


export default function Person(record, aodService)
{
    AodObject.call(this, record, aodService, 'Person');
};

Person.getOwnerType = function(personType)
{
    let ownerType;
    switch (personType) {
        case 'AdvertiserPerson':
            ownerType ='Advertiser';
            break;
        case 'ProductionUnitPerson':
            ownerType ='ProductionUnit';
            break;
        default:
            ownerType ='Account';
    }
    return ownerType;
};

Person.prototype = Object.create(
    AodObject.prototype,
    {

        // TODO thsi is bollocks - see aod.Project for setting up prototype properties
        getOwnerType: {value: function() {
                return Person.getOwnerType(this.personType);
            }},
        getOwner: {value: function()
            {
                // todo getAodItem is a messed up piece if code
                this.owner = this.getAodItem(this.getOwnerType(),'ownerId');
                return this.owner;
            }},

        //getters & setters
        fullName: {
            get: function() {
                return this.firstName +' '+this.lastName;
            },
            enumerable: true
        },
        fullEmail: {
            get: function() {
                return this.fullName + ' <'+this.email+'>';
            },
            enumerable: true
        },
        displayName: {  //TBD how to do root object getter / setter ?
            get: function() {
                return this.fullName + ' ('+this.userName+')';
            },
            enumerable: true
        }
    }
);

Person.prototype.constructor = Person;